<template>
  <div class="listing__details" :class="dynamicClasses" @click="triggerSelected">
    <div v-if="isBooked">
      <a :href="bookingUrl" class="listing__href_card">
        <div class="listing__card">
          <div class="listing__heading">{{ createDetails }}</div>
          <div class="listing__time">{{ timeFrame }}</div>
        </div>
      </a>
    </div>
    <div v-else class="listing__card">
      <div class="listing__heading">{{ createDetails }}</div>
      <div class="listing__time">{{ timeFrame }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import capitalize from 'lodash/capitalize';
import { format, parseISO } from 'date-fns';

const TYPE_DEFAULT = 'Booked';
const TYPE_INTERVIEW = 'Interview'; // from InterviewContract
const TYPE_BOOKING = 'Booking';

export default {
  name: 'AvailabilityCard',
  props: {
    availability: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dynamicClasses(): any {
      const classes = { 'listing__details--active': this.active };
      classes[`listing__details--${this.availability.node.kind.toLowerCase()}`] = true;
      return classes;
    },
    createDetails(): string {
      const availability = this.availability.node;
      let details;

      if (availability.cause) {
        details = this.createBookedDetails(availability);
      } else {
        details = capitalize(availability.kind);
      }

      return details;
    },
    timeFrame(): string {
      const s = parseISO(this.availability.node.start);
      const e = parseISO(this.availability.node.end);

      if (s.getDay() === e.getDay()) {
        if (format(s, 'a') === format(e, 'a')) {
          return `${format(s, 'h:mm')} - ${format(e, 'h:mm aaa')}`;
        }
        return `${format(s, 'h:mm aaa')} - ${format(e, 'h:mm aaa')}`;
      }
      return `${format(s, 'h:mm aaa')} - ${format(e, 'h:mm aaa (eee)')}`;
    },
    isBooked(): boolean {
      return this.availability.node.cause !== undefined && this.availability.node.cause !== null;
    },
    bookingUrl(): string {
      return this.isBooked ? `/bookings/${this.availability.node.cause.id}` : '';
    },
  },
  methods: {
    createBookedDetails(availability: any): string {
      let bookedType = TYPE_DEFAULT;
      const type = availability?.cause?.interviewContractKind;
      let fullName = availability.cause.parent.name.split(' ');

      if (type === 'booking') {
        bookedType = TYPE_BOOKING;
      } else {
        bookedType = TYPE_INTERVIEW;
      }

      fullName = fullName.map((name) => capitalize(name)).join(' ');

      return `${bookedType} with ${fullName}`;
    },
    triggerSelected() {
      if (!this.isBooked) {
        this.$emit('selected', this.availability);
      }
    },
  },
};
</script>
